import { h, Component } from 'preact'

import PostAPI from '../api/PostAPI'
import Posts from '../components/Posts'
import PostSlider from '../containers/PostSlider'
import StyleFilter from './StyleFilter'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      posts: [],
      isLoading: false,
      error: false,
      currentTerms: {
        product_model: '',
        product_style: ''
      }
    }

    this.handleTermChoice = this.handleTermChoice.bind(this)
  }

  componentDidMount() {
    /**
     * Get product model from pageblock
     * and fetch all matching posts.
     */
    this.setState(
      {
        currentTerms: {
          product_model: this.props.model,
          product_style: ''
        }
      },
      this.fetchPosts
    )
  }

  fetchPosts() {
    this.setState({ isLoading: true })

    PostAPI.all(this.state)
      .then(response => response.json())
      .then(data => {
        window.setTimeout(() => {
          this.setState({
            posts: [...this.state.posts, ...data],
            isLoading: false
          })
        }, 500)
      })
      .catch(error => {
        this.setState({
          error: true,
          isLoading: false
        })
      })
  }

  handleTermChoice(currentTerm, taxonomy) {
    const currentTerms = this.state.currentTerms
    currentTerms[taxonomy] = currentTerm

    this.setState(() => {
      return {
        currentTerms: currentTerms,
        posts: []
      }
    }, this.fetchPosts)
  }

  render() {
    let headerClass =
      this.props.sliderVisiblity !== 'hide'
        ? 'c-products-app__header'
        : 'c-products-app__header c-products-app__header--no-slider'
    const { title, defaultOption } = this.props
    return (
      <div className="c-products-app">
        <div className={headerClass}>
          <div className="c-products-app__filters">
            <StyleFilter
              currentTerm={this.state.currentTerms.product_style}
              onSelectTerm={this.handleTermChoice}
              model={this.props.model}
              postsLoading={this.state.isLoading}
              defaultOption={defaultOption}
              title={title}
            />
          </div>

          {this.props.sliderVisiblity !== 'hide' && !this.state.isLoading ? (
            <PostSlider posts={this.state.posts} slidesCount={this.state.posts.length} />
          ) : null}
        </div>

        <div className="c-products-app__body">
          <Posts
            posts={this.state.posts}
            loading={this.state.isLoading}
            error={this.state.error}
            appointment={this.props.appointment}
            invoice={this.props.invoice}
          />
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/js/products/containers/App.js